import { render, staticRenderFns } from "./ReceitaTable.vue?vue&type=template&id=3950d23c"
import script from "./ReceitaTable.vue?vue&type=script&lang=js"
export * from "./ReceitaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports